import FlagEN from 'assets/flag_en.png';
import FlagIT from 'assets/flag_it.png';

import { Image } from 'components/Image';

import * as S from './FlagLabel.styles';
import { FlagName } from './types';

type FlagLabelProps = {
  type: FlagName;
  plain?: boolean;
};

export function FlagLabel(props: FlagLabelProps): React.ReactElement {
  const { type, plain } = { ...props };

  return (
    <S.Container plain={plain}>
      <Image source={type === 'it' ? FlagIT : FlagEN} alt={`${type} flag`} height="2rem" />
    </S.Container>
  );
}
